<template>
  <div>
    <v-card flat>
      <v-card-title class="headline">
        Coming Soon!
      </v-card-title>
      <v-card-text class="headline">
        If you feel having a schedule is important to you, please let us know using the 'Feedback' button in the top right corner.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    search: "",
    lf: false,
    expand: false,
    dealers: ["Dealer 1", "Dealer 2", "Dealer 3", "Dealer 4"],
    headers: [
      { text: "Dealer", value: "dealer", sortable: true },
      { text: "Client", value: "client", sortable: true },
      { text: "Standard", value: "std", sortable: true },
      { text: "Type", value: "type" },
      { text: "Date Due", value: "testdate" }
    ],
    desserts: [],
    editedIndex: -1,
    editedItem: {
      dealer: "",
      client: "",
      std: "",
      testdate: "",
      type: ""
    },
    defaultItem: {
      dealer: "",
      client: "",
      std: "",
      testdate: "",
      type: ""
    }
  }),
  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.desserts = [
        {
          dealer: "Dealer 1",
          client: "Broward F.D.",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/03/19"
        },
        {
          dealer: "Dealer 1",
          client: "Miami F.D.",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/12/19"
        },
        {
          dealer: "Dealer 2",
          client: "Lakeland F.D.",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/12/19"
        },
        {
          dealer: "Dealer 2",
          client: "Delray F.D.",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/17/19"
        },
        {
          dealer: "Dealer 3",
          client: "Active",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/18/19"
        },
        {
          dealer: "Dealer 3",
          client: "Active",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/28/19"
        },
        {
          dealer: "Dealer 4",
          client: "Active",
          std: "NFPA 1989",
          type: "Accreditation",
          testdate: "11/29/19"
        }
      ]
    }
  }
}
</script>
